import Router from '@pages/admins'
import AdminsList from '@pages/admins/list/list-admins'
import RolesLists from '@pages/admins/list/list-roles'
import AdminProfile from '@pages/admins/admin/profile/profile'
import AdminHistory from '@pages/admins/admin/history/history'
import AdminPermissions from '@pages/admins/admin/permissions/permissions'

export default {
  path: 'admins/',
  components: {
    default: Router,
  },

  children: [{
    path: '',
    redirect: () => ({
      name: 'admins-list',
    })
  }, {
    path: 'users',
    name: 'admins-list',
    components: { 
      default: AdminsList,
    },
  }, {
    path: 'roles',
    name: 'roles-list',
    components: { 
      default: RolesLists,
    },
  }, {
    path: ':id/profile/',
    name: 'admin-profile',
    components: { 
      default: AdminProfile,
    },
  }, {
    path: ':id/history/',
    name: 'admin-history',
    components: { 
      default: AdminHistory,
    },
  }, {
    path: ':id/permissions/',
    name: 'admin-permissions',
    components: { 
      default: AdminPermissions,
    },
  }],
}